import * as React from 'react'

import { CaretDownIcon, CaretUpIcon, Link } from 'main/ui'
import { Container, IconContainer } from './ToggleableLink.styles'

interface IProps {
  children: React.ReactNode
  open: boolean
  onChange: (open: boolean) => void
}

function ToggleableLink(props: IProps) {
  const { children, open, onChange } = props

  return (
    <Container onClick={() => onChange(!open)}>
      <Link to="#">{children}</Link>
      <IconContainer>{open ? <CaretUpIcon /> : <CaretDownIcon />}</IconContainer>
    </Container>
  )
}

export default React.memo(ToggleableLink)
